<template>
    <div class='h-full w-full flex flex-row flex-wrap'>
      <div class='w-full lg:w-3/5 xl:w-1/2 lg:pr-4'>
        <FullCalendar
          ref="fullCalendar"
          class='demo-app-calendar'
          :options='calendarOptions'
        >
          <template v-slot:eventContent='arg'>
            <i class="truncate-1">{{ arg.event.title }}</i>
          </template>
        </FullCalendar>
      </div>
      <div class='w-full lg:w-2/5 xl:w-1/2 lg:pl-8 mt-8 lg:mt-0'>
        <div class='h-full flex flex-col'>
          <div class="flex justify-between items-start">
            <h1 class="text-xl mb-8">All Events ({{ eventsList.length }})</h1>
            <div class="flex justify-start items-center">
              <div class="text-sm mr-2">Weekends</div>
              <base-toggle :toggle="calendarOptions.weekends" @set-checkbox-val="setCheckboxVal"></base-toggle>
            </div>
          </div>
          <div v-if="isLoading">
            <event-calendar-card-shimmer class="mb-8" v-for="(loadingCard, index) in 3" :key="index"></event-calendar-card-shimmer>
          </div>
          <div v-else class="flex-auto">
            <div v-if="eventsList.length > 0">
              <event-calendar-card v-for='event in eventsList' :key='event.id' :item="event" :selected-event-id="selectedEventId"  class="mb-8"></event-calendar-card>
            </div>
            <div v-else class="h-full flex flex-col justify-center items-center">
              <p class="text-center text-base sm:text-xl">No events!</p>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { converToDateTime } from '../../helpers/utils.js'
import EventCalendarCard from '../../components/events/EventCalendarCard.vue';
import EventCalendarCardShimmer from '../../components/events/EventCalendarCardShimmer.vue';
export default {
    name: "event-calendar",
    components: {
      FullCalendar,
      EventCalendarCard,
      EventCalendarCardShimmer,
    },
    data() {
      return {
        calendarOptions: {
          plugins: [
            dayGridPlugin,
            timeGridPlugin,
            interactionPlugin
          ],
          headerToolbar: {
              left: 'prev,next today',
              center: 'title',
              right: 'dayGridMonth,timeGridWeek,timeGridDay'
          },
          initialView: 'dayGridMonth',
          editable: false,
          selectable: true,
          selectMirror: true,
          dayMaxEvents: true,
          weekends: true,
          select: this.handleDateSelect,
          eventClick: this.handleEventClick,
          eventsSet: this.handleEvents,
          datesSet: this.handleDatesSet,
          events: [],
        },
        currentEvents: [],
        eventsList: [],
        selectedEventId: null,
        isLoading: false,
      }
  },
  methods: {
    setCheckboxVal(checkbox) {
      this.calendarOptions.weekends = checkbox;
    },
    handleWeekendsToggle() {
      this.calendarOptions.weekends = !this.calendarOptions.weekends
    },
    handleEventClick(clickInfo) {
      if (this.selectedEventId == clickInfo.event.id) {
        this.selectedEventId = null;
      } else {
        this.selectedEventId = clickInfo.event.id;
      }
    },
    handleDateSelect() {
      this.selectedEventId = null;
    },
    handleEvents(events) {
      this.currentEvents = events
    },
    async handleDatesSet(dateInfo) {
      this.isLoading = true;
      try {
        const { data } = await this.$apollo.query({
          query: gql`query GetEventsCalendar($start_date: DateTime!, $end_date: DateTime!) {
                getEventsCalendar(start_date: $start_date, end_date: $end_date) {
                  id
                  title
                  slug
                  thumbnail
                  description
                  start_date
                  end_date
                  location
                  display_time
                  display_day
                }
          }`,
          variables: {
            start_date: converToDateTime(dateInfo.startStr),
            end_date: converToDateTime(dateInfo.endStr),
          },
          fetchPolicy: 'network-only'
        });

        this.eventsList = data.getEventsCalendar;
        const formattedEvents = this.eventsList.map(event => {
            return {
                id: event.id,
                title: event.title,
                start: event.start_date,
                end: event.end_date
            }
        });

        this.calendarOptions.events = formattedEvents;
        
      } catch (error) {
        console.log(error.message);
      }
      this.isLoading = false;
    },
  },
}
</script>


<style lang="scss">
.fc-header-toolbar.fc-toolbar.fc-toolbar-ltr {
  flex-wrap: wrap;
}
a.fc-event.fc-event-start.fc-event-end.fc-event-past.fc-daygrid-event.fc-daygrid-dot-event {
    background-color: red;
    color: white;
}
a.fc-event.fc-event-start.fc-event-end.fc-event-future.fc-daygrid-event.fc-daygrid-dot-event {
    background-color: green;
    color: white;
}
.truncate-1 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}
</style>